export default "__VITE_ASSET__e389da68__"